var map = {
	"./Gifs (1)/Gifs/step1.gif": 1742,
	"./Gifs (1)/Gifs/step2.gif": 2378,
	"./Gifs (1)/Gifs/step3.gif": 767,
	"./Gifs (1)/Gifs/step4.gif": 7660,
	"./Gifs (1)/Gifs/step5.gif": 6251,
	"./step1.gif": 2645,
	"./step2.gif": 5747,
	"./step3.gif": 4369,
	"./step4.gif": 8885,
	"./step5.gif": 2736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5482;